import React from 'react';
import Select from 'react-select';
import {
    bool,
    func,
    string,
    array,
    object,
    oneOfType,
} from 'prop-types';

export default function PollingTypeSelect(props: any) {
    const {
        pollingTypeLabel,
        options,
        isMulti,
        onChange,
        value,
    } = props;
    
    return (
        <>
            <Select
                className="polling-type__multi-select"
                onChange={onChange}
                value={value}
                variant="outlined"
                options={options}
                isMulti={isMulti}
            />
            <div className="polling-type__label">
                {pollingTypeLabel}
            </div>
        </>
    );
}

PollingTypeSelect.propTypes = {
    pollingTypeLabel: string.isRequired,
    options: array.isRequired,
    isMulti: bool.isRequired,
    onChange: func.isRequired,
    value: oneOfType([
        object,
        array,
    ]).isRequired,
};
